import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/homepage/header";
import { About } from "../components/homepage/about";

import { Contact } from "../components/homepage/contact";

import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { SiteData } from "../constants/interfaces";
import { defaultSiteData } from "../constants/globals";
import { Join } from "../components/homepage/join";
import { Projects } from "../components/homepage/projects";

/*
import { Features } from "../components/homepage/features";
import { Services } from "../components/homepage/services";
import { Gallery } from "../components/homepage/gallery";
import { Testimonials } from "../components/homepage/testimonials";
import { Team } from "../components/homepage/Team";
import { Apply } from "../components/homepage/apply";
*/

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = () => {
  const [landingPageData, setLandingPageData] = useState<SiteData>(defaultSiteData);
  useEffect(() => {
    // the data import is sus, idk how to fix
    //@ts-ignore
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
        {/* A LOT OF THESE COMPONENTS ARE REDUNDANT AND/OR HAVE CONFLICTING NAMES WITH PAGES
        CONFLICTING NAMES:
        /components/homepage/about */}
      <Navigation />
      <Header data={landingPageData?.Header} />
      {/*

      PROBABLY WONT NEED, MAYBE ADD BACK LATER?
      <Features data={landingPageData.Features} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
       */}
      
      <About data={landingPageData?.About} />
      <Join data={landingPageData.Features} />
      <Projects data={landingPageData.AboutProjects}/>
      <Contact data={landingPageData?.Contact} />
    </div>
  );
};

export default Home;